import classNames from "classnames"
import css from './Page.module.scss'

export default function Page({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
    return <div className={classNames(css.page, className)} {...props} />
} 